// extracted by mini-css-extract-plugin
export var equalColumn = "_g8-0";